import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Checkbox from "material-ui/Checkbox";

const styles = () => ({
  root: {
    padding: "20px",
    boxSizing: "border-box",
    height: "100%",
    display: "flex",
    alignItems: "center",
  },
  checkbox: {
    width: "20px",
    height: "20px",
  },
});

const CheckBox = ({ classes, checked, item, index, handleSelectItem }) => {
  return (
    <div className={classes.root}>
      <Checkbox
        checked={checked}
        onChange={() => handleSelectItem(item, index, !checked)}
        color="primary"
        className={classes.checkbox}
      />
    </div>
  );
};

CheckBox.propTypes = {
  classes: PropTypes.object.isRequired,
  checked: PropTypes.bool.isRequired,
  isStarCheckBox: PropTypes.bool,
  item: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  handleSelectItem: PropTypes.func.isRequired,
};

CheckBox.defaultProps = {
};

export default withStyles(styles)(CheckBox);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/Spreadsheet/parts/CheckBox.jsx